import { z } from "zod";
import { defineStepConfig } from "../../../registry/helpers";

/**
 * Prepare Summary Email
 *
 * Fan-out adapter between Summarize Collection Threads and Send Email. Receives
 * one member's email address (the fan-out branch) plus the shared subject/body,
 * and emits them in the shape Send Email expects (`to` as a single-element
 * array). Connect Summarize's `recipientEmails` array to `recipientEmail` to
 * trigger the per-member fan-out.
 */
export const prepareSummaryEmailStep = defineStepConfig({
  type: "prepare_summary_email",
  name: "Prepare Summary Email",
  description:
    "Adapt one Team member's address + the shared digest into Send Email " +
    "inputs (one individual email per member).",
  category: "Data Transform",
  libraryModule: "AccountsReceivable",

  inputSchema: z.object({
    recipientEmail: z
      .string()
      .describe(
        "A single Team member's email. Connect Summarize Collection Threads' " +
          "'recipientEmails' array here to fan out per member.",
      ),
    subject: z.string().describe("Shared digest subject (broadcast)."),
    htmlContent: z.string().describe("Shared digest HTML body (broadcast)."),
  }),

  outputSchema: z.object({
    to: z
      .array(z.string())
      .describe("Single-recipient 'to' list for Send Email."),
    subject: z.string(),
    htmlContent: z.string(),
  }),

  configSchema: z.object({}),

  emits: [] as const,

  execution: {
    startToCloseTimeout: "15 seconds",
    retry: {
      maximumAttempts: 3,
      backoffCoefficient: 2,
      initialInterval: "5 seconds",
    },
  },
});
